import './layout.css'

export function ResponsiveRow({children, align, justify}) {

    return (
        <div className={`responsive-row ${align} justify-${justify}`}>
            {children}
        </div>
    )
}